import { Route } from "found";


import MyAcknowledgmentsForLine from "./for_line/MyAcknowledgmentsForLine";
import MyAcknowledgmentHistory from "./mine/all/MyAcknowledgmentHistory";
import MyPoliciesToAcknowledgeReport from "./mine/MyPoliciesToAcknowledgeReport";

import { environment } from "pstat-anywhere/relay";
import { ContentContainer } from "pstat-anywhere/components/pages";

const AcknowledgmentsWrapper = ({ children }) => (
  <ContentContainer>{children}</ContentContainer>
);
const routes = (
  <Route path="acknowledgment" Component={AcknowledgmentsWrapper}>
    <Route
      path="mine"
      Component={MyPoliciesToAcknowledgeReport}
      prepareVariables={(params, { location }) => ({
        ...params,
        queryName: location.query.name
      })}
      render={({ Component, props }) => (
        <Component {...props} environment={environment}>
          {props.children}
        </Component>
      )}
    />
    <Route
      path="mine/all"
      Component={MyAcknowledgmentHistory}
      prepareVariables={(params, { location }) => ({
        ...params,
        queryName: location.query.name
      })}
      render={({ Component, props }) => (
        <Component {...props} environment={environment}>
          {props.children}
        </Component>
      )}
    />
    <Route
      path="line/:linePk(\d+)"
      Component={MyAcknowledgmentsForLine}
      prepareVariables={(params, { location }) => ({
        ...params,
        queryName: location.query.name
      })}
      render={({ Component, props }) => (
        <Component {...props} environment={environment}>
          {props.children}
        </Component>
      )}
    />
  </Route>
);

export default routes;
